enum CommunityNavigationWidgetMode {
    auto = 0,
    desktop = 1,
    mobile = 2
}

export default CommunityNavigationWidgetMode;